import type { WorkerListItem } from "../types";

export interface EmployeesDepartmentGroup {
  key: string;
  departmentId: number | null;
  code: string;
  name: string;
  workers: WorkerListItem[];
}

/** Bucket the already-sorted rows into department blocks for the table view.
 *
 *  Order inside a block is left untouched — it is whatever the page's active
 *  sort produced — while the blocks themselves follow the org structure:
 *  by index, then by name, with the unassigned block last, because it reads as
 *  a leftover rather than as a department. */
export function groupEmployeesByDepartment(employees: WorkerListItem[]): EmployeesDepartmentGroup[] {
  const groups = new Map<string, EmployeesDepartmentGroup>();

  for (const worker of employees) {
    const department = worker.department;
    const key = department ? String(department.id) : "none";

    let group = groups.get(key);
    if (!group) {
      group = {
        key,
        departmentId: department?.id ?? null,
        code: department?.code ?? "",
        name: department?.name_ru ?? "",
        workers: [],
      };
      groups.set(key, group);
    }

    group.workers.push(worker);
  }

  return Array.from(groups.values()).sort(function byStructureOrder(a, b) {
    if (a.departmentId === null) return 1;
    if (b.departmentId === null) return -1;
    const byCode = a.code.localeCompare(b.code, "ru", { numeric: true });
    if (byCode !== 0) return byCode;
    return a.name.localeCompare(b.name, "ru");
  });
}
